import ListProducts from "theme/components/ListProducts";
import React from "react";
import SearchFilterContainer from "core-web/containers/SearchFilterContainer";
import SearchHero from "theme/components/search/SearchHero";
import SearchSuggestions from "./SearchSuggestions";
import config from "theme/config/filter";
import getQueryParams from "core-web/utils/getQueryParams";
import { isEmpty } from "core-web/utils/object";
import { useLocation } from "react-router-dom";
import useSaveResponse from "core-web/hooks/useSaveResponse";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Events from "core-web/libs/Events";
import { SearchEvents } from "core-web/libs/Events/constants";

const tracking = (query, products) => {
    if (!query) {
        return;
    }

    Events.trigger(SearchEvents.SUBMITTED, { query, products });
};

const Search = () => {
    const { t } = useTranslation();
    const location = useLocation();

    const productsPerPage =
        useSelector(({ page }) => page.data.product_grid?.product_grid?.settings?.products_per_page) || "";

    // Save response from container
    const [savedResponse, saveResponse] = useSaveResponse();

    const pageSize = parseInt(productsPerPage || "36", 10);

    const params = getQueryParams(location);
    let query = params.q || "";

    try {
        query = decodeURI(query);
    } catch (e) {
        // console.error(e);
    }

    return (
        <>
            <SearchFilterContainer
                indices={{
                    articles: { firstPageSize: 12, pageSize: 12, page: 1 },
                    categoriesBrands: { pageSize: 12 },
                    suggestions: { pageSize: 12 },
                }}
                productProps={{
                    config: config,
                    distinct: true,
                    filters: [],
                    firstPageSize: pageSize,
                    pageSize,
                    saveSortState: false,
                    sort: "products",
                    // ruleContexts: (ruleContexts || []).map((rule) => rule.value),
                    ruleContexts: [],
                }}
                search={query}
                render={({ response }) => {
                    saveResponse(response, ["productsData"]);

                    if (isEmpty(savedResponse.current)) {
                        return null;
                    }

                    const { productsData } = savedResponse.current;
                    const productHits = productsData.hitsCount || 0;

                    tracking(query, productsData.products);

                    return (
                        <>
                            <SearchHero location={location} query={query} t={t} />

                            {!!productHits ? (
                                <ListProducts
                                    isSearchPage
                                    isFirstModule
                                    response={productsData}
                                    config={config}
                                    searchQuery={query}
                                />
                            ) : (
                                <SearchSuggestions query={query} />
                            )}
                        </>
                    );
                }}
            />
        </>
    );
};

export default Search;
